import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user } = useAuth();

  if (user?.rol !== 'Admin' && user?.rol !== 'SuperAdmin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
